/*
Usage Notes:

The following web component can be dropped into any standard Shopify theme (i.e. non-headless), using Liquid to pass product data:

  <skio-plan-picker
    product='{{ product | json | escape }}'
    selectedVariant='{{ product.selected_or_first_available_variant | json | escape }}'
    formId='{{ product_form_id }}'
    >
  </skio-plan-picker>
  <script src="{{ 'skio-plan-picker-component.js' | asset_url }}" type="module"></script>

  Note: formId not required if element is inside of a form already
*/

import { LitElement, html, css, unsafeHTML } from 'https://cdn.jsdelivr.net/gh/lit/dist@2/all/lit-all.min.js';
// LitJS Core https://cdn.jsdelivr.net/gh/lit/dist@2/core/lit-core.min.js
// LitJS ALL (includes directives) https://cdn.jsdelivr.net/gh/lit/dist@2/all/lit-all.min.js

const skioStyles = css`
  :host {
    width: 100%;
    display: block;
    margin-bottom: 1rem;
  }

  .skio-plan-picker {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 0;
    border: 0;
  }

  .skio-onetime-second {
    order: 2;
  }
  
  .skio-group-container {
    display: none;
  }
  .skio-group-container--available {
    display: block;
    position: relative;
    border: 1px solid black;
    transition: border-color 0.2s ease;
    padding: 21px 16px;
  }
  
  .skio-group-container--selected {
    background: white;
  }
  
  .skio-group-input {
    position: absolute;
    width: 0px;
    height: 0px;
    opacity: 0;
  }
  .skio-group-input:focus-visible ~ .skio-group-label {
    outline: 2px #ccc solid;
    outline-offset: 4px;
    border-radius: 5px;
  }
  
  .skio-group-label {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    overflow: hidden;
  }
  
  .skio-group-topline {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    width: 100%;
    font-size: 16px;
  }

  .skio-group-container[skio-subscription] .skio-group-topline {
    align-items: flex-start;
  }
  
  .skio-radio__container {
    display: flex;
    margin-right: 10px;
  }
  
  .skio-radio {
    transition: transform 0.25s cubic-bezier(0.4,0,0.2,1), opacity 0.25s cubic-bezier(0.4,0,0.2,1);
    transform-origin: center;
    transform: scale(0);
    opacity: 0;
  }
  .skio-group-label:hover .skio-radio {
    transform: scale(1);
    opacity: 0.75;
  }
  .skio-group-container--selected .skio-group-label .skio-radio {
    transform: scale(1);
    opacity: 1;
  }
  
  .skio-price {
    margin-left: auto;
    font-size: 16px;
  }

  .skio-price span {
    font-weight: 600;
  }
  
  .skio-group-content {
    width: auto;
    margin-left: 30px;
    transition: max-height 0.25s cubic-bezier(0.4,0,0.2,1),
                opacity 0.25s cubic-bezier(0.4,0,0.2,1);
    max-height: 50px;
    opacity: 1;
  }
  
  /* Hide frequency if not selected */
  .skio-group-container:not(.skio-group-container--selected) .skio-group-content {
    max-height: 0;
    opacity: 0;
    pointer-events: none;
  }
  
  .skio-group-title {
    font-weight: 500;
    font-size: 16px;
  }
  
  .skio-save {
    color: #0fa573;
    border: 1px #0fa573 solid; 
    padding: 0px 8px;
    border-radius: 20px;
  }
  
  .skio-frequency {
    display: flex;
    align-items: center;
    gap: 5px;
    margin-top: 5px;
    border-radius: 5px;
    width: 100%;
    font-size: 16px;
    font-weight: 400;
    white-space: nowrap;
    text-overflow: ellipsis;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='h-6 w-6' fill='none' viewBox='0 0 24 24' stroke='currentColor' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7' /%3E%3C/svg%3E");
    background-position: right 10px top 50%;
    background-size: 18px;
    background-repeat: no-repeat;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;

    border: 1px solid black;
    background-color: transparent;
    padding: 10px;
    margin-bottom: 40px;
    border-radius: 0;
  }
  .skio-frequency.skio-frequency--one {
    background-image: none;
  }
  
  .skio-frequency span {
    text-transform: lowercase;
  }

  .subscription-callout {
    color: #185674;
    margin-left: 38px;
  }

  .ex-benefit {
    margin-left: 38px;
    margin-top: 12px;
    display: flex;
    margin-bottom: 12px;
  }

  .ex-benefit .img {
    width: 74px;
    margin-right: 10px;
  }

  .ex-benefit img {
    width: 100%;
  }

  .ex-benefit ul {
    flex: 1;
    margin: 0;
    padding-left: 0;
  }

  .ex-benefit li {
    list-style: none;
    position: relative;
    padding: 2px 5px 3px 25px;
    font-size: 14px;
  }

  .ex-benefit li:before {
    position: absolute;
    content: "";
    display: block;
    width: 20px;
    height: 20px;
    background-image: url('https://dogbydrlisa.com/cdn/shop/t/91/assets/ico-checli.svg');
    background-size: cover;
    left: 0;
    top: 2px;
  }

  @media only screen and (max-width: 767px) {
    .skio-group-title, .skio-price {
      font-size: 12px;
    }

    .skio-group-container {
      padding: 16px 8px;
    }

    .ex-benefit li {
      padding: 0 0 0 21px;
      font-size: 12px;
    }

    .ex-benefit li:before {
      width: 15px;
      height: 15px;
    }

    .ex-benefit .img {
      width: 54px;
    }

    .subscription-callout {
      font-size: 12px;
    }

    .skio-group-title {
      max-width: 65%;
    }
  }
`;

export class SkioPlanPickerComponent extends LitElement {
  static properties = {
    product: { type: Object },            //required
    productHandle: { type: String },      //optional (unless product isn't passed, then required)
    key: { type: String },                //optional, defaults to product.id; identifier for this instance of the Skio plan picker

    subscriptionFirst: { type: Boolean }, //optional, defaults to false; if true, shows subscription option above onetime
    startSubscription: { type: Boolean }, //optional, defaults to false; if true, auto-selects subscription on page load
    hideSelect: { type: Boolean }, // optional, defaults to false; if true, hides the select dropdown
    discountFormat: { type: String },     //optional, defaults to percent; can also pass "fixed"

    currency: { type: String },           //optional, defaults to 'USD', but can pass any 3 char identifier
    language: { type: String },           //optional, defaults to 'en-US', but can pass any similarly formatted language identifier
    moneyFormatter: {},                   //placeholder for object

    selectedVariant: { type: Object },    //placeholder for data
    skioSellingPlanGroups: {},            //placeholder for data
    availableSellingPlanGroups: {},       //placeholder for data
    selectedSellingPlanGroup: {},         //placeholder for data
    selectedSellingPlan: {},              //placeholder for data

    benefits: { type: String },
    showBenefits: { state: true }
  };

  static styles = skioStyles;

  constructor() {
    super();

    this.product = null;
    this.selectedVariant = null;

    this.productHandle = null;

    this.key = null;

    this.skioSellingPlanGroups = null;
    this.availableSellingPlanGroups = null;

    this.selectedSellingPlanGroup = null;
    this.selectedSellingPlan = null;

    this.startSubscription = false;
    this.subscriptionFirst = false;
    this.hideSelect = false;

    this.skioMainProduct = true;

    this.discountFormat = 'percent';

    this.currency = 'USD';
    this.language = 'en-US';
    this.moneyFormatter = new Intl.NumberFormat(this.language, {
      style: 'currency',
      currency: this.currency,
      minimumFractionDigits: 0,
    });
  }

  connectedCallback() {
    super.connectedCallback();

    if(!this.product && this.productHandle) {
      this.fetchProduct(this.productHandle);
    }

    this.bindFormEvents();
  }

  radioTemplate() {
    return html`<div class="skio-radio__container">
    <svg
      width="28"
      height="28"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke="#707070"
        stroke-width="1"
      ></circle>
      <circle
        class="skio-radio"
        cx="12"
        cy="12"
        r="6"
        fill="#185674"
      ></circle>
    </svg>
  </div>`
  }

  render() {
    if(!this.product || !this.selectedVariant || !this.selectedVariant.selling_plan_allocations.length) return;

    return html` <fieldset
      class="skio-plan-picker"
      skio-plan-picker="${this.key}"
    >
      <div
        class="skio-group-container ${this.product.requires_selling_plan ==
        false
          ? "skio-group-container--available"
          : ""} ${this.selectedSellingPlanGroup == null
          ? "skio-group-container--selected"
          : ""} ${this.subscriptionFirst ? "skio-onetime-second" : ""}"
        skio-group-container
        @click=${() => this.selectSellingPlanGroup(null)}
      >
        <input
          id="skio-one-time-${this.key}"
          class="skio-group-input"
          name="skio-group-${this.key}"
          type="radio"
          value=""
          skio-one-time
          ?checked=${this.startSubscription == false &&
          this.product.requires_selling_plan == false
            ? true
            : false}
        />
        <label class="skio-group-label" for="skio-one-time-${this.key}">
          <div class="skio-group-topline">
            ${this.radioTemplate()}

            <div class="skio-group-title">
              ONE TIME PURCHASE
            </div>

            <div class="skio-price">
              ${this.selectedVariant.compare_at_price && this.selectedVariant.compare_at_price > this.selectedVariant.price ? html`
                <s>${this.moneyFormatter.format(
                  this.selectedVariant.compare_at_price / 100
                )}</s>
              ` : ''}

              <span skio-onetime-price
                >${this.moneyFormatter.format(
                  this.selectedVariant.price / 100
                )}</span
              >
            </div>
          </div>
        </label>
      </div>
      ${this.availableSellingPlanGroups
        ? this.availableSellingPlanGroups.map(
            (group, index) =>
              html`
                <div
                  class="skio-group-container skio-group-container--available ${this
                    .selectedSellingPlanGroup == group
                    ? "skio-group-container--selected"
                    : ""}"
                  skio-group-container
                  skio-subscription
                  @click=${() => this.selectSellingPlanGroup(group)}
                >
                  <input
                    id="skio-selling-plan-group-${index}-${this.key}"
                    class="skio-group-input"
                    name="skio-group-${this.key}"
                    type="radio"
                    value="${group.id}"
                    skio-selling-plan-group="${group.id}"
                    ?checked=${this.selectedSellingPlanGroup == group
                      ? true
                      : false}
                  />
                  <label
                    class="skio-group-label"
                    for="skio-selling-plan-group-${index}-${this.key}"
                  >
                    <div class="skio-group-topline">
                      ${this.radioTemplate()}
                      <div class="skio-group-title">
                        ${group.name == 'Subscription' ? 'Subscribe & Save' : group.name}
                        ${this.discount(group.selected_selling_plan).percent !==
                        "0%"
                          ? html`
                            - Get <strong>
                                <span skio-discount
                                  >${this.discountFormat == "percent"
                                    ? this.discount(group.selected_selling_plan)
                                        .percent
                                    : this.discount(group.selected_selling_plan)
                                        .amount}</span
                                > off</strong>
                            `
                          : html``}
                      </div>

                      <div class="skio-price">
                        ${this.discount(group.selected_selling_plan).percent !== "0%" ? html`
                          <s>${this.moneyFormatter.format(
                            this.selectedVariant.price / 100
                          )}</s>
                        `: ''}
                        <span skio-subscription-price
                          >${this.price(group.selected_selling_plan)}</span
                        >
                      </div>

                      <div class="subscription-callout">NO COMMITMENT: SKIP OR CANCEL ANYTIME</div>
                      ${ this.showBenefits ? html`<div class="ex-benefit">${unsafeHTML(this.benefits)}</div>` : '' }
                    </div>
                    <div class="skio-group-content">
                      ${!this.hideSelect
                        ? html`
                            <select
                              skio-selling-plans="${group.id}"
                              class="skio-frequency"
                              @change=${(e) =>
                                this.selectSellingPlan(e.target, group)}
                            >
                              ${group
                                ? group.selling_plans
                                    .filter((selling_plan) =>
                                      this.selectedVariant.selling_plan_allocations.some(
                                        (allocation) =>
                                          allocation.selling_plan_id ==
                                          selling_plan.id
                                      )
                                    )
                                    .map(
                                      (selling_plan) =>
                                        html`
                                          <option 
                                            ?selected=${group.selected_selling_plan.id === selling_plan.id}
                                            value="${selling_plan.id}">
                                            ${group.name == "Subscription"
                                              ? `Please Deliver: ${selling_plan.name}`
                                              : `${selling_plan.name}`}
                                          </option>
                                        `
                                    )
                                : ""}
                            </select>
                          `
                        : ""}
                    </div>
                  </label>
                </div>
              `
          )
        : ""}
    </fieldset>`;
  }

  updated = (changed) => {
    if(changed.has('product') && this.product) {
      //update key
      this.key = this.key ? this.key : this.product.id;

      //update skioSellingPlanGroups
      this.skioSellingPlanGroups = this.product.selling_plan_groups.filter(
        selling_plan_group => selling_plan_group.app_id === 'SKIO'
      )
    }

    if(changed.has('selectedVariant') && this.selectedVariant) {
      if(this.selectedVariant.title === '80 pack') {
        this.showBenefits = false;
      } else {
        this.showBenefits = true;
      }

      //update availableSellingPlanGroups based on skioSellingPlanGroups and selectedVariant.id
      this.availableSellingPlanGroups = this.skioSellingPlanGroups.filter(selling_plan_group =>
        selling_plan_group.selling_plans.some(selling_plan =>
          this.selectedVariant.selling_plan_allocations.some(
            selling_plan_allocation => selling_plan_allocation.selling_plan_id === selling_plan.id
          )
        )
      )

      //update selectedSellingPlan value
      if (this.availableSellingPlanGroups?.length > 0) {
        const url = new URL(window.location.href);
        const urlSelectedSellingPlanId = url.searchParams.get('selling_plan');

        //update each group with a default selected_selling_plan
        this.availableSellingPlanGroups.forEach((group => {
          let availableSellingPlans = group.selling_plans.filter(selling_plan =>
            this.selectedVariant.selling_plan_allocations.some(
              selling_plan_allocation => selling_plan_allocation.selling_plan_id === selling_plan.id
            )
          );

          group.selected_selling_plan = availableSellingPlans.find((plan) => {
            let urlSelectedIsAvailable = availableSellingPlans.some(plan => plan.id == urlSelectedSellingPlanId)
            if(urlSelectedIsAvailable) {
              this.log('is available return true')
              return plan.id == urlSelectedSellingPlanId
            }
          }) || availableSellingPlans[0];
        }));

        if (this.startSubscription == true || this.product.requires_selling_plan == true || this.selectedSellingPlan || urlSelectedSellingPlanId) {
          this.selectedSellingPlanGroup = this.availableSellingPlanGroups.find(group => group.selected_selling_plan.id == this.availableSellingPlanGroups[0].selected_selling_plan.id);
          this.selectedSellingPlan = this.availableSellingPlanGroups[0].selected_selling_plan;
        } else {
          this.selectedSellingPlan = null;
          this.selectedSellingPlanGroup = null;
        }
      }

      this.updateForm();
    }

    if(changed.has('selectedSellingPlan')) {
      this.updateURLParams();

      //update price of price elements if applicable
      document.querySelectorAll(`[skio-price][skio-key="${ this.key }"]`).forEach((el) => {
        el.innerHTML = this.price(this.selectedSellingPlan);
      });

      //update display of external content elements
      document.querySelectorAll(`[skio-onetime-content][skio-key="${ this.key }"]`).forEach((el) => {
        this.selectedSellingPlan !== null ? el.style.display = "none" : el.style.removeProperty('display');
      });

      document.querySelectorAll(`[skio-subscription-content][skio-key="${ this.key }"]`).forEach((el) => {
        this.selectedSellingPlan == null ? el.style.display = "none" : el.style.removeProperty('display');
      });

      //dispatch CustomEvent to tell that this specific plan picker was updated, and pass the selectedSellingPlan
      const event = new CustomEvent(`skio::update-selling-plan`, {
        bubbles: true,
        composed: true,
        detail: {
          variant: this.selectedVariant,
          sellingPlan: this.selectedSellingPlan,
          key: this.key
        }
      });

      this.dispatchEvent(event);

      this.updateForm();
    }
  }

  bindFormEvents() {
    this.form = this.closest('form[action*="/cart/add"]')

    if (!this.form) {
      return
    }

    this.variantInput = this.form.querySelector('[name="id"]')

    if (this.variantInput) {
      this.variantInput.addEventListener('change', (e) => {
        this.selectedVariant = this.product.variants.find((variant) => variant.id == e.target.value);
        this.variantChanged = true;
      })
    }
  }

  log = (...args) => {
    args.unshift('%c[skio]', 'color: #8770f2;');
    // console.log.apply(console, args);
  }

  error = (...args) =>  {
    args.unshift('%c [skio]', 'color: #ff0000');
    console.error.apply(console, args);
  }

  // Update selected selling plan group; called on click of skio-group-container element
  selectSellingPlanGroup(group) {
    this.selectedSellingPlanGroup = group;
    this.selectedSellingPlan = group?.selected_selling_plan;

    //update the form that was passed, if any
    this.updateForm();
      if (typeof updateAfterpay === 'function') {
          updateAfterpay();
      }
  }

  // Update selected selling plan; called on change of skio-frequency select element
  selectSellingPlan(element, group) {
    let selling_plan = group.selling_plans.find(x => x.id == element.value);
    if (selling_plan) {
      group.selected_selling_plan = selling_plan;
      this.selectedSellingPlanGroup = group;
      this.selectedSellingPlan = selling_plan;
    }
    else this.log("Error: couldn't find selling plan with id " + element.value + " for variant " + this.selectedVariant.id + " from product " + this.product.id + " : " + this.product.handle);

  }

  updateURLParams() {
    const url = new URL(window.location.href);

    if(this.selectedSellingPlan) {
      this.log('updating url with params', this.selectedSellingPlan)
      url.searchParams.set('selling_plan', this.selectedSellingPlan.id);
      window.history.replaceState({}, '', url.href);
    } else {
      url.searchParams.delete('selling_plan');
      window.history.replaceState({}, '', url.href);
    }
  }

  // Formats integer value into money value
  money(price) {
    return this.moneyFormatter.format(price / 100.0)
  }

  // Calculates discount based on selling_plan.price_adjustments, returns { percent, amount } of selling plan discount
  discount(selling_plan) {
    if (!selling_plan)
      return { percent: '0%', amount: 0 }

    this.log('discount selling_plan', selling_plan)
    this.log('discount selling_plan.price_adjustments', selling_plan.price_adjustments)

    const price_adjustment = selling_plan.price_adjustments[0]
    const discount = { percent: '0%', amount: 0 }
    const price = this.selectedVariant.price;

    switch (price_adjustment.value_type) {
      case 'percentage':
        discount.percent = `${price_adjustment.value}%`
        discount.amount = Math.round(
          (price * price_adjustment.value) / 100.0
        )
        break
      case 'fixed_amount':
        discount.percent = `${Math.round(
          ((price_adjustment.value * 1.0) / price) * 100.0
        )}%`
        discount.amount = price_adjustment.value
        break
      case 'price':
        discount.percent = `${Math.round(
          (((price - price_adjustment.value) * 1.0) /
            price) *
            100.0
        )}%`
        discount.amount = price - price_adjustment.value
        break
    }

    return discount
  }

  // Calculates the variant's price for the given selling plan, returns a formatted money value (if desired)
  price(selling_plan, formatted = true) {
    return formatted
      ? this.money( this.selectedVariant.price - this.discount(selling_plan).amount)
      :  this.selectedVariant.price - this.discount(selling_plan).amount
  }

  // Updates element data to be registered by forms
  updateForm() {
    let $sellingPlan = this.querySelector('input[name=selling_plan]');
    if($sellingPlan) $sellingPlan.value = this.selectedSellingPlan ? this.selectedSellingPlan.id : '';

    let $comparePrice = document.querySelector('[data-compare-price]')
    let $price = document.querySelector('[data-product-price]')

    if($comparePrice) {
      let comparePrice = this.selectedVariant.compare_at_price && this.selectedVariant.compare_at_price > this.selectedVariant.price ? this.selectedVariant.compare_at_price : this.selectedVariant.price;
      let price = this.price(this.selectedSellingPlan, false);

      if(comparePrice <= price) {
        $comparePrice.style.display = 'none';
      } else {
        $comparePrice.style.display = '';
      }

      $comparePrice.innerText = this.money(comparePrice);
    }

    if($price) {
      let price = this.price(this.selectedSellingPlan, false);
      $price.innerText = this.money(price);
    }
  }

  // Optional functions keep if necessary

  /**
   *
   *
   */

  // Runs a fetch request to add the selectedVariant to the cart with the passed quantity and selectedSellingPlan
  addToCart(quantity) {
    const items = [
      {
        id: this.selectedVariant.id,
        quantity: quantity,
        ...(this.selectedSellingPlan && { selling_plan: this.selectedSellingPlan?.id })
      }
    ];

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items })
    })
    .then((response) => response.json())
    .then((response) => {
      this.log("SKIO added item to cart: ", response);
      //dispatch CustomEvent to tell document that an item was added to cart
      const event = new CustomEvent(`skio::added-to-cart`, {
        bubbles: true,
        composed: true,
        detail: {
          response,
          key: this.key
        }
      });

      this.dispatchEvent(event);
    })
    .catch((error) => {
      this.error(`SKIO ${ this.key } error adding item to cart: `, error);
    });
  }

  fetchProduct = (handle) => {
    return fetch(`/products/${ handle }.js`)
    .then((response) => response.json())
    .then((product) => {
      this.product = product;
      this.selectedVariant = product.variants[0];

      return product;
    });
  }
}

customElements.define('skio-plan-picker', SkioPlanPickerComponent);
